<template>
	<layout-page-v2 class="appointment-list" icon="sethoscope" h1="Appointments">
		<div slot="btn-group" class="btn-group">
			<button-icon-text-loading @click.native="openModal({ action: 'add' })" icon="plus-w" class="plus btn-add">{{ $t('buttons.actions.add_appointment') }}</button-icon-text-loading>
		</div>
		<appointment-navigation :user_uid="user_uid" :watch_id="watch_id"/>
		<spinner v-if="appointments.loading"/>
		<error-box v-else-if="appointments.error" :error="appointments.error"/>
		<div v-else>
			<div v-if="appointments.data.length" class="idi-table appointments">
				<div class="idi-header">
					<div class="idi-cell">{{ $t('labels.general.date') }}</div>
					<div class="idi-cell">{{ $t('labels.general.hour') }}</div>
					<div class="idi-cell">{{ $t('labels.general.name') }}</div>
					<div class="idi-cell">{{ $t('labels.general.location') }}</div>
					<div class="idi-cell">{{ $t('labels.general.description') }}</div>
					<div class="idi-cell"></div>
				</div>
				<div class="idi-row" v-for="appointment in appointments.data" :key="appointment.id">
					<div class="idi-cell grid-area-date">
						<div>{{ date(appointment.date) }}</div>
						<div>{{ date_day_name(appointment.date) }}</div>
					</div>
					<div class="idi-cell grid-area-hour">
						<span>{{ time(appointment.date) }}</span>
					</div>
					<div class="idi-cell grid-area-name">
						<span>{{ appointment.name }}</span>
					</div>
					<div class="idi-cell grid-area-location">
						<span>{{ appointment.location }}</span>
					</div>
					<div class="idi-cell grid-area-description">
						<span>{{ appointment.description }}</span>
					</div>
					<div class="idi-cell grid-area-operations">
						<button-icon-loading @click.native="editAppointment(appointment.id)" icon="edit" class="btn-edit"/>
						<button-icon-loading @click.native="deleteAppointment(appointment.id)" :loading="deleting.has(appointment.id)" icon="trash" class="btn-delete"/>
					</div>
				</div>
			</div>
			<p v-else>{{ $t('base.general.no_results') }}</p>
		</div>
		<appointment-form v-if="modalBox.open" @close="closeModal" :params="modalBox.params" :user_uid="user_uid" :watch_id="watch_id"/>
	</layout-page-v2>
</template>

<script>
import AppointmentNavigation from './AppointmentNavigation'
import AppointmentForm from './AppointmentForm'
export default {
	components: {
		AppointmentNavigation,
		AppointmentForm
	},
	props: [
		'user_uid',
		'watch_id'
	],
	data () {
		return {
			appointments: {
				loading: false,
				data: [],
				error: null
			},
			deleting: new Set(),
			modalBox: {
				open: false,
				params: {}
			}
		}
	},
	watch: {
		'$route' (to, from) {
			this.getAppointments()
		}
	},
	methods: {
		date (date) {
			return this.$moment(date).format('D MMM \'YY')
		},
		date_day_name (date) {
			if (this.$moment(date).isSame(this.$moment(), 'day')) {
				return 'Today'
			}
			return this.$moment(date).format('dddd');
		},
		time (date) {
			return this.$moment(date).format('HH:mm')
		},
		getAppointments () {
			switch (this.$route.name) {
				case 'WatchAppointmentAll':
					this.getAppointmentsAll()
					break
				case 'WatchAppointmentUpcoming':
					this.getAppointmentsUpcoming()
					break
				default:
					// do nothing
			}
		},
		getAppointmentsAll () {
			this.appointments.loading = true
			this.appointments.data = []
			this.$api.appointments.getAll(this, this.user_uid, this.watch_id).then(response => {
				this.$log.info('watch appointments', 'appointments.getAll OK', response)()
				this.appointments.data = response.body
			}).catch(error => {
				this.$log.error('watch appointments', 'appointments.getAll ERROR', error)()
				this.appointments.error = error
			}).finally(() => {
				this.appointments.loading = false
			})
		},
		getAppointmentsUpcoming () {
			this.appointments.loading = true
			this.appointments.data = []
			this.$api.appointments.getUpcoming(this, this.user_uid, this.watch_id).then(response => {
				this.$log.info('watch appointments', 'appointments.getUpcoming OK', response)()
				this.appointments.data = response.body
			}).catch(error => {
				this.$log.error('watch appointments', 'appointments.getUpcoming ERROR', error)()
				this.appointments.error = error
			}).finally(() => {
				this.appointments.loading = false
			})
		},
		editAppointment (id) {
			this.openModal({ action: 'edit', id })
		},
		deleteAppointment (id) {
			if (confirm('Delete?')) {
				this.deleting.add(id)
				this.$forceUpdate()
				this.$api.appointments.delete(this, this.user_uid, this.watch_id, id).then(response => {
					this.$log.info('watch appointments', 'appointments.delete OK', response)()
				}).catch(errors => {
					this.$log.error('watch appointments', 'appointments.delete ERROR', errors)()
				}).finally(() => {
					this.deleting.delete(id)
					this.getAppointments()
				})
			}
		},
		openModal (params = {}) {
			this.modalBox.open = true
			this.modalBox.params = params
		},
		closeModal (params) {
			this.modalBox.open = false
			this.modalBox.params = {}

			if (params.reload) {
				this.getAppointments()
			}
		}
	},
	beforeCreate () {
		this.$title('Appointments')
	},
	mounted () {
		this.getAppointments()
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/appointments/AppointmentList.vue